var map = {
	"./apidays-2021-banner.jpg": "4e32",
	"./apidays-2021-snapshot-1.jpg": "9196",
	"./apidays-2021-snapshot-2.jpg": "c4e7",
	"./apidays-2021-snapshot-3.jpg": "e0fd",
	"./apidays-2021-snapshot-4.jpg": "9395",
	"./apidays-2021-snapshot-5.jpg": "9fba",
	"./apidays-2021-snapshot-6.jpg": "84fb",
	"./apidays-live-hongkong-2021-agenda-825.png": "5b2d",
	"./apidays-live-hongkong-2021-agenda-826.png": "9290",
	"./apidays-live-hongkong-2021-participants.png": "3e92",
	"./apidays-live-hongkong-2021-video-cover.jpg": "a35f",
	"./hongkong.jpg": "2aa0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "09f8";